<template>
  <div v-if="isVisible" class="m-related-objects">
    <!-- created works -->
    <RelatedSearchResults
      v-if="actor?.createdWorks"
      ref="createdWorks"
      :search-params="actor.createdWorks.params"
      :heading="createdWorksHeading"
      :sub-heading="createdWorksSubheading"
      :aria-heading="ariaCreatedWorksHeading"
      :cta-search-label="createdWorksHeading.toLowerCase()"
      :heading-level="3"
      :max-items-per-row="6"
      :items="actor.createdWorks.results.data"
      :total="actor.createdWorks.results.total"
      :use-route="true"
    />
    <!-- owned works -->
    <RelatedSearchResults
      v-if="showOwnedWorks && actor?.ownedWorks"
      ref="ownedWorks"
      :search-params="actor.ownedWorks.params"
      :heading="ownedWorksHeading"
      :sub-heading="ownedWorksSubheading"
      :aria-heading="ariaOwnedWorksHeading"
      :cta-search-label="ownedWorksHeading.toLowerCase()"
      :heading-level="3"
      :max-items-per-row="6"
      :items="actor.ownedWorks.results.data"
      :total="actor.ownedWorks.results.total"
      :use-route="true"
    />
    <GridOfItems
      v-if="actor?.relatedExhibitions?.length > 0"
      ref="relatedExhibitions"
      class="m-related-objects__exhibitions"
      :heading="relatedExhibitionsHeading"
      :aria-heading="ariaRelatedExhibitionsHeading"
      :items="actor?.relatedExhibitions"
      :max-items-per-row="4"
      :show-count="true"
      :show-top-border="true"
      :total="actor?.relatedExhibitions.length"
      total-label-key="actor_page.related_exhibitions_count"
    />
    <GridOfItems
      v-if="actor?.relatedVideos?.length > 0"
      ref="relatedVideos"
      class="m-related-objects__videos"
      :heading="relatedVideosHeading"
      :aria-heading="ariaRelatedVideosHeading"
      :items="actor?.relatedVideos"
      :max-items-per-row="3"
      :show-count="true"
      :show-top-border="true"
      :total="actor?.relatedVideos.length"
      total-label-key="actor_page.related_videos_count"
    />
  </div>
</template>

<script>
import { useLocalization, GridOfItems } from "@thegetty-private/getty-ui";
import RelatedSearchResults from "@/components/molecules/relatedSearchResults/index.vue";

export default {
  name: "ConstituentRelatedObjects",
  components: { GridOfItems, RelatedSearchResults },

  props: {
    /**
     * The transformed actor object from the store
     */
    actor: {
      type: Object,
      required: false,
      default: undefined
    },
    /**
     * Whether to show "owned works" related search results
     */
    showOwnedWorks: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  setup(props) {
    return {
      ...useLocalization({
        baseLocaleKey: props?.baseLocaleKey
      })
    };
  },

  data() {
    return {
      /**
       * Translated text for the created works heading (aria label)
       */
      ariaCreatedWorksHeading: this.translatePart(
        "actor_page.created_works_aria"
      ),
      /**
       * Translated text for the created works heading (aria label)
       */
      ariaOwnedWorksHeading: this.translatePart("actor_page.owned_works_aria"),
      /**
       * Translated text for the related exhibitions heading (aria label)
       */
      ariaRelatedExhibitionsHeading: this.translatePart(
        "actor_page.related_exhibitions_aria"
      ),
      /**
       * Translated text for the related exhibitions heading (aria label)
       */
      ariaRelatedVideosHeading: this.translatePart(
        "actor_page.related_videos_aria"
      ),
      /**
       * Translated text for the created works heading
       */
      createdWorksHeading: this.translatePart("actor_page.created_works"),
      /**
       * Translated text for the created works subheading
       */
      createdWorksSubheading: this.translatePart(
        "actor_page.created_works_subheading"
      ),
      /**
       * Translated text for the owned works heading
       */
      ownedWorksHeading: this.translatePart("actor_page.owned_works"),
      /**
       * Translated text for the owned works subheading
       */
      ownedWorksSubheading: this.translatePart(
        "actor_page.owned_works_subheading"
      ),
      /**
       * Translated text for the related exhibitions heading
       */
      relatedExhibitionsHeading: this.translatePart(
        "actor_page.related_exhibitions_heading"
      ),
      /**
       * Translated text for the related videos heading
       */
      relatedVideosHeading: this.translatePart(
        "actor_page.related_videos_heading"
      )
    };
  },
  computed: {
    /**
     * whether the component has any content
     *
     * @returns {boolean}
     */
    isVisible() {
      return (
        this.actor?.relatedExhibitions?.length > 0 ||
        this.actor?.relatedVideos?.length > 0 ||
        this.actor?.createdWorks?.results?.total > 0 ||
        this.actor?.ownedWorks?.results?.total > 0
      );
    }
  }
};
</script>

<style lang="scss">
@import "./index.scss";
</style>
